import React, { useEffect, useState } from "react";
// import styles from "./FlightBookingDetail.module.css";
// import { Container, Col, Row } from "react-bootstrap";
import "./FlightDetail.css";
// import FlightDetailSkeleton from "./FlightDetailSkeleton";
// import FlightDetailSide from "./FlightDetailSide";

// import FlightPayModal from "./FlightPayModal";
// import { MdFlightLand } from "react-icons/md";
import { FaAngleDown, FaRegThumbsUp } from "react-icons/fa";
import { Link, useLocation, useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import {
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  FormControl,
  Nav,
  Modal,
  Tab,
  Card,
  Button,
} from "react-bootstrap";
import { HiPlusSmall } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { HiMiniMinusSmall } from "react-icons/hi2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import DepatureDetail from "./DepartureDetail";
import FlightDetailSkeleton from "./FlightDetailSkeleton";
import GoodToKnow from "./GoodToKnow";
import FareRule from "./FareRule";
import { cities12 } from "../../Cities";
import ChargesOneWay from "./ChargesOneWay";
import TravellerInformation from "./TravellerInformation";
import BDSend from "./BDSend";
import FlightPayModal from "./FlightPayModal";
import ChargesRound from "./ChargesRound";
import SSRContent from "./SSRContent";
import { Markup } from "../../redux/services/operations/markup";
import { FaClock } from "react-icons/fa6";
import { resetTimer } from "../../redux/slices/flightSlice";
import { countryCode } from "../../CountryCode";
import { toast } from "react-toastify";
import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";

import "dayjs/locale/en-gb";
import { countries } from "../../Countries";
// import GoodToKnow from "./GoodToKnow";
// import FlightPayDetail from "./FlightPayDetail";
// import FareRule from "./FareRule";
// import SSRContent from "./SSRContent";F
// import ChargesOneWay from "./ChargesOneWay";
// import BDSend from "./BDSend";
// import TravellerInformation from "./TravellerInformation";
// import EmiModal from "./EmiModal";

const FlightDetail = () => {
  const timer = useSelector((state) => state.flight.timer);
  const { walletData } = useSelector((state) => state.auth);
  // const timer = localStorage.getItem("timer");

  const [walletDatas, setWalletDatas] = useState(0);
  const [creditLimits, setCreditLimits] = useState(0);
  useEffect(() => {
    const data = localStorage.getItem("walletBalance");
    const datas = localStorage.getItem("CreditLimit");
    if (data) {
      setWalletDatas(data);
    }
    if (datas) {
      setCreditLimits(datas);
    }
  }, []);
  const [openPayBtn, setOpenPayBtn] = useState(false);
  // const { index } = useParams();
  const decodedIndex = decodeURIComponent(useParams().index);
  const decodedIndex2 = decodeURIComponent(useParams().index2);
  const [flight, setFlight] = useState(null);
  const [fareRule, setFareRule] = useState(null);
  const [ssrResponse, setSsrResponse] = useState(null);
  const [flight2, setFlight2] = useState(null);
  const [fareRule2, setFareRule2] = useState(null);
  const [ssrResponse2, setSsrResponse2] = useState(null);
  const [emiBtn, setEmiBtn] = useState(false);
  const search = useSelector((state) => state.flight.search);
  // const { traceId } = useSelector((state) => state.flight);
  // const { token } = useSelector((state) => state.auth);
  const [passengerBaggagePreferences, setPassengerBaggagePreferences] =
    useState([]);
  const [passengerSeatPreferences, setPassengerSeatPreferences] = useState([]);
  const [passengerMealPreferences, setPassengerMealPreferences] = useState([]);
  const [bookingKey, setBookingKey] = useState(() =>
    String(sessionStorage.getItem("bookingId") || "")
  );
  const [token, setToken] = useState(() =>
    String(localStorage.getItem("token") || "")
  );
  const [fareActive, setFareActive] = useState(true);

  const parseFareRule = (fareRuleDetail) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = fareRuleDetail;
    const listItems = Array.from(tempDiv.querySelectorAll("li")).map((li) =>
      li.textContent.trim()
    );

    return listItems;
  };
  const storedBookingKey = String(sessionStorage.getItem("bookingId"));
  const storedToken = String(localStorage.getItem("token"));
  const [tokenss, setTokenss] = useState(storedToken);
  const [bookingKeyss, setBookingKeyss] = useState(storedBookingKey);
  const dispatch = useDispatch();
  const [gstAllow, setGstAllow] = useState("");
  const [showsessionModal, setShowsessionModal] = useState(false);

  // Effect to open the modal when the timer hits 0
  useEffect(() => {
    if (timer.minutes === 0 && timer.seconds === 0) {
      setShowsessionModal(true);
    }
  }, [timer]);

  // Function to handle closing the modal and resetting the timer or starting a new search
  const handleOk = () => {
    setShowsessionModal(false);
    dispatch(resetTimer());
    navigate(-1, { replace: true });
    // Optionally, navigate to the search page or trigger a new search
  };

  useEffect(() => {
    // Prevent API call if dependencies are not ready
    if (!decodedIndex || !bookingKey || !token) {
      console.log("Waiting for decodedIndex, bookingKey, or token...");
      return;
    }

    console.log("Running API call with:", {
      decodedIndex,
      decodedIndex2,
      bookingKey,
      token,
    });

    const fetchData = async () => {
      try {
        const response1 = await axios.post(
          "https://admin.yatriservice.com/api/flightfarerule",
          {
            Id: walletData.Email,
            BookingKey: bookingKey,
            ContractId: decodedIndex,
          }
        );

        setFareActive(true);

        const response2 = await axios.post(
          "https://admin.yatriservice.com/api/flightsell",
          {
            Id: walletData.Email,
            BookingKey: bookingKey,
            ContractId:
              decodedIndex2 && decodedIndex2 !== "undefined"
                ? `${parseInt(decodedIndex)}^${parseInt(decodedIndex2)}`
                : decodedIndex,
          }
        );
        console.log("response2", response2);
        if (response2.data.success) {
          setFareActive(false);

          const sellData = response2.data.data.Sell;
          const contracts = sellData.Contracts;

          // Enrich AirSegments with city data
          contracts.forEach((contract) => {
            contract.AirSegments.forEach((segment) => {
              const departureCode = segment.Origen;
              const arrivalCode = segment.Destination;

              segment.DepartureCity = cities12.find(
                (city) => city.AIRPORTCODE === departureCode
              );
              segment.ArrivalCity = cities12.find(
                (city) => city.AIRPORTCODE === arrivalCode
              );
            });
          });

          setFlight(contracts[0]);
          setFlight2(contracts[1]);
          setGstAllow(response2.data.data.IsGSTMandatory);
          setFareRule(response1.data.data.FareRule);

          const newPassengers = contracts[0].PexFareDetails.flatMap(
            ({ PaxType, TotPax }) => {
              const typeLabel =
                PaxType === 1 ? "Adult" : PaxType === 2 ? "Child" : "Infant";
              return Array.from({ length: TotPax }, (_, index) => ({
                id: index + 1,
                type: typeLabel,
                name: `Passenger ${index + 1}`,
              }));
            }
          );

          setPassengers(newPassengers);
          console.log("newPassengers", newPassengers);
        } else {
          navigate("/agent/404");
        }

        console.log("response1", response1);
        console.log("response2", response2);
      } catch (error) {
        console.error("Error fetching flight data:", error);
        toast.error("Unable to sell, please go back and try again");
        navigate("/agent/dashboard");
      }
    };

    const markupData = {
      AgentId: walletData.Id,
    };

    dispatch(Markup(markupData));
    fetchData();
  }, [decodedIndex, decodedIndex2, bookingKey, token]);

  const [domesticMarkup, setDomesticMarkup] = useState(0);
  const InternationalMarkup = parseInt(localStorage.getItem("add-int"));
  useEffect(() => {
    const storedFare = localStorage.getItem("add-dom");

    if (storedFare) {
      let finalPrice =
        storedFare !== undefined && storedFare !== null ? storedFare : 0;
      setDomesticMarkup(parseInt(finalPrice));
    } else {
      setDomesticMarkup(0);
    }
  }, [search]);

  const [promoCode, setPromoCode] = useState("");
  const [appliedCode, setAppliedCode] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleApply = () => {
    // Apply logic here
    setAppliedCode(promoCode);
    setSuccessMessage("Promo code applied successfully!");
    setPromoCode("");
  };

  const handleClear = () => {
    // Clear logic here
    setAppliedCode("");
    setSuccessMessage("");
  };

  const navigate = useNavigate();
  const handlePayment = () => {
    navigate("/agent/flight-ticket");
  };

  const formatTime = (arrTime) => {
    const date = new Date(arrTime);
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = days[date.getDay()];
    const dateNum = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day}, ${dateNum} ${month} ${year}`;
  };
  const [loading, setLoading] = useState(false);
  const [showdetail, setShowdetail] = useState(false);

  const [activeTab, setActiveTab] = useState(0);
  const [passengers, setPassengers] = useState([]);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const [formData, setFormData] = useState([]);
  const [childData, setChildData] = useState([]);
  const [infant, setInfant] = useState([]);

  const [gstData, setGstData] = useState({
    GSTNNumber: "",
    GSTCompanyName: "",
    GSTCompanyContact: "",
    GSTCompanyEmailId: "",
    GSTCompanyAddress: "",
  });
  const handleInputGST = (e) => {
    const { name, value } = e.target;

    setGstData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const cleanedName = name.replace(/\d+/g, ""); // Remove numeric parts from the name

    // Create a copy of the current formData
    const list = [...formData];

    // Ensure the index exists in the list
    if (!list[index]) {
      list[index] = {};
    }

    // Handle date-specific validation and formatting if the field is for a date
    if (cleanedName === "date" && dayjs(value).isValid()) {
      // Save the date in YYYY-MM-DD format
      list[index][cleanedName] = dayjs(value).format("YYYY-MM-DD");
    } else if (cleanedName !== "date") {
      // For other fields, save the raw value
      list[index][cleanedName] = value;
    } else {
      // Log an invalid date input
      console.log("Invalid date");
    }

    // Update the formData state
    setFormData(list);
    console.log("Updated formData:", formData);
  };
  const handleInputChange1 = (index, e) => {
    const { name, value } = e.target;
    const cleanedName = name.replace(/\d+/g, ""); // Remove numeric parts from the name

    // Create a copy of the current formData
    const list = [...childData];

    // Ensure the index exists in the list
    if (!list[index]) {
      list[index] = {};
    }

    // Handle date-specific validation and formatting if the field is for a date
    if (cleanedName === "date" && dayjs(value).isValid()) {
      // Save the date in YYYY-MM-DD format
      list[index][cleanedName] = dayjs(value).format("YYYY-MM-DD");
    } else if (cleanedName !== "date") {
      // For other fields, save the raw value
      list[index][cleanedName] = value;
    } else {
      // Log an invalid date input
      console.log("Invalid date");
    }

    // Update the formData state
    setChildData(list);
    console.log("Updated formData:", formData);
  };
  const handleInputChange2 = (index, e) => {
    const { name, value } = e.target;
    const cleanedName = name.replace(/\d+/g, ""); // Remove numeric parts from the name

    // Create a copy of the current formData
    const list = [...infant];

    // Ensure the index exists in the list
    if (!list[index]) {
      list[index] = {};
    }

    // Handle date-specific validation and formatting if the field is for a date
    if (cleanedName === "date" && dayjs(value).isValid()) {
      // Save the date in YYYY-MM-DD format
      list[index][cleanedName] = dayjs(value).format("YYYY-MM-DD");
    } else if (cleanedName !== "date") {
      // For other fields, save the raw value
      list[index][cleanedName] = value;
    } else {
      // Log an invalid date input
      console.log("Invalid date");
    }

    // Update the formData state
    setInfant(list);
    console.log("Updated formData:", formData);
  };
  // const handleInputChange1 = (index, e) => {
  //   const { name, value } = e.target;
  //   const cleanedName = name.replace(/\d+/g, "");

  //   const list = [...childData];
  //   if (!list[index]) {
  //     list[index] = {};
  //   }
  //   list[index][cleanedName] = value;
  //   setChildData(list);
  // };
  // const handleInputChange2 = (index, e) => {
  //   const { name, value } = e.target;
  //   const cleanedName = name.replace(/\d+/g, "");

  //   const list = [...infant];
  //   if (!list[index]) {
  //     list[index] = {};
  //   }
  //   list[index][cleanedName] = value;
  //   setInfant(list);
  // };
  const isValidExpiryDate = (index, date) => {
    const flightArrTime = !flight2
      ? new Date(
          flight.AirSegments[flight.AirSegments.length - 1].ArrivalDateTime
        )
      : new Date(
          flight2.AirSegments[flight2.AirSegments.length - 1].ArrivalDateTime
        );

    const expiryDate = new Date(date);

    const sixMonthsAfterArrTime = new Date(
      flightArrTime.setMonth(flightArrTime.getMonth() + 6)
    );

    return expiryDate >= sixMonthsAfterArrTime;
  };

  const handleExpiryDateChange = (index, e) => {
    const { value } = e.target;
    if (!isValidExpiryDate(index, value)) {
      alert("The expiry date must be at least 6 months after the flight date.");
    } else {
      handleInputChange(index, e);
    }
  };

  const handleExpiryDateChange1 = (index, e) => {
    const { value } = e.target;
    if (!isValidExpiryDate(index, value)) {
      alert("The expiry date must be at least 6 months after the flight date.");
    } else {
      handleInputChange1(index, e);
    }
  };

  const handleExpiryDateChange2 = (index, e) => {
    const { value } = e.target;
    if (!isValidExpiryDate(index, value)) {
      alert("The expiry date must be at least 6 months after the flight date.");
    } else {
      handleInputChange2(index, e);
    }
  };

  const isValidDateOfBirth = (date) => {
    const currentDate = new Date();
    const dob = new Date(date);
    let age = currentDate.getFullYear() - dob.getFullYear();
    const monthDiff = currentDate.getMonth() - dob.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && currentDate.getDate() < dob.getDate())
    ) {
      age--;
    }

    return age >= 12;
  };

  const isValidDateOfBirth1 = (date) => {
    const currentDate = new Date();
    const dob = new Date(date);
    let age = currentDate.getFullYear() - dob.getFullYear();
    const monthDiff = currentDate.getMonth() - dob.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && currentDate.getDate() < dob.getDate())
    ) {
      age--;
    }

    return age >= 2 && age < 12;
  };

  const isValidDateOfBirth2 = (date) => {
    const currentDate = new Date();
    const dob = new Date(date);
    let age = currentDate.getFullYear() - dob.getFullYear();
    const monthDiff = currentDate.getMonth() - dob.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && currentDate.getDate() < dob.getDate())
    ) {
      age--;
    }

    return age < 2;
  };

  const handleDOBChange = (index, e) => {
    const { value } = e.target;
    if (!isValidDateOfBirth(value)) {
      alert("The age must be greater than 12 years.");
    } else {
      handleInputChange(index, e);
    }
  };

  const handleDOBChange1 = (index, e) => {
    const { value } = e.target;
    if (!isValidDateOfBirth1(value)) {
      alert("The age must be between 2 to 12 years.");
    } else {
      handleInputChange1(index, e);
    }
  };

  const handleDOBChange2 = (index, e) => {
    const { value } = e.target;
    if (!isValidDateOfBirth2(value)) {
      alert("The age must be less than 2 years.");
    } else {
      handleInputChange2(index, e);
    }
  };
  // console.log(formData);
  // console.log(childData);
  // console.log(infant);
  const [isinternational, setIsInternational] = useState(false);
  // useEffect(() => {
  //   if (flight) {
  //     // Extract the origin and destination airport codes
  //     const originAirportCode = flight.AirSegments[0].Origen;
  //     const destinationAirportCode =
  //       flight.AirSegments[flight.AirSegments.length - 1].Destination;

  //     // Find the corresponding city objects from cities12 array
  //     const originCity = cities12.find(
  //       (city) => city.AIRPORTCODE === originAirportCode
  //     );
  //     const destinationCity = cities12.find(
  //       (city) => city.AIRPORTCODE === destinationAirportCode
  //     );

  //     // Check if both city objects are found and compare their COUNTRYCODE
  //     if (
  //       originCity &&
  //       destinationCity &&
  //       originCity.COUNTRYCODE !== destinationCity.COUNTRYCODE
  //     ) {
  //       setIsInternational(true);
  //     }
  //   }
  // }, [flight]);

  useEffect(() => {
    if (flight) {
      // Extract the origin and destination airport codes
      const originAirportCode = flight.AirSegments[0].Origen;
      const destinationAirportCode =
        flight.AirSegments[flight.AirSegments.length - 1].Destination;

      // Find the corresponding city objects from cities12 array
      const originCity = cities12.find(
        (city) => city.AIRPORTCODE === originAirportCode
      );
      const destinationCity = cities12.find(
        (city) => city.AIRPORTCODE === destinationAirportCode
      );

      // Check if either origin or destination is an international city
      if (
        (originCity &&
          countryCode.some((cc) => cc.code === originCity.COUNTRYCODE)) ||
        (destinationCity &&
          countryCode.some((cc) => cc.code === destinationCity.COUNTRYCODE))
      ) {
        setIsInternational(true);
      } else {
        setIsInternational(false);
      }
    }
  }, [flight, cities12]);

  const { adminDm, adminIm, agentDm, agentIm } = useSelector(
    (state) => state.markUp
  );

  const calculateTotalFareDeduct = (response, markup) => {
    const PexFareDetailss = (flight && flight?.PexFareDetails) || [];

    // Calculate total passengers (TotPax)
    const totalPax = PexFareDetailss.reduce(
      (sum, detail) => sum + (detail.TotPax || 0),
      0
    );
    const totalFare = response + markup * totalPax;

    return totalFare;
  };

  const markup = isinternational ? adminIm : adminDm;
  const agentmarkup = isinternational ? agentIm : agentDm;

  // const [markups, setMarkups] = useState([]);

  const totalPassengers =
    flight &&
    flight.PexFareDetails.reduce(
      (sum, detail) => sum + (detail.TotPax || 0),
      0
    );

  const [citiess, setCitiess] = useState([]);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await axios.get(
          "https://admin.flyabasin.com/api/airport"
        );
        setCitiess(response.data.data);
        console.log("RESPONSE CITIES", response.data.data);
      } catch (error) {
        console.error("Error fetching cities12 data:", error);
      }
    };
    fetchCities();
  }, []);

  const [markups, setMarkups] = useState({ agent: [], admin: [] });
  useEffect(() => {
    const AgentId = walletData.Id;

    const fetchMarkups = async () => {
      try {
        // Fetch agent-level markup
        const agentResponse = await axios.post(
          `https://admin.yatriservice.com/api/agent-markup/all`,
          { AgentId }
        );

        // Fetch admin-level markup
        const adminResponse = await axios.post(
          `https://admin.yatriservice.com/api/markup`,
          { AgentId } // Assuming admin doesn't need an AgentId
        );

        if (agentResponse.data.success === true) {
          setMarkups((prevState) => ({
            ...prevState,
            agent: agentResponse.data.data || [],
          }));
          console.log("Agent Markup Response", agentResponse.data.data);
        }

        if (adminResponse.data.success === true) {
          setMarkups((prevState) => ({
            ...prevState,
            admin: adminResponse.data.data || [],
          }));
          console.log("Admin Markup Response", adminResponse.data.data);
        }
      } catch (error) {
        console.error("Error fetching markup data:", error);
      }
    };

    fetchMarkups();
  }, [walletData]);

  const calculateFareDeduct = (
    baseFare,
    markups,
    totalPassengers,
    flightCode
  ) => {
    const flightType = isinternational ? "international" : "domestic";

    const applicableAdminMarkups =
      markups?.admin?.filter((markup) => markup.flight_type === flightType) ||
      [];

    if (applicableAdminMarkups.length === 0) {
      console.warn(
        `No applicable admin markups found for flight type: ${flightType}`
      );
      return baseFare;
    }

    const airlineWiseAdminMarkup = applicableAdminMarkups.find(
      (markup) =>
        markup.markup_type === "airline_wise" &&
        markup.flight_code === flightCode
    );

    const generalAdminMarkup = applicableAdminMarkups.find(
      (markup) => markup.markup_type === "all"
    );

    const selectedAdminMarkup = airlineWiseAdminMarkup || generalAdminMarkup;

    let updatedFare = baseFare;

    if (selectedAdminMarkup) {
      if (selectedAdminMarkup.service_type === "fixed") {
        const totalServiceFee =
          parseFloat(selectedAdminMarkup.service_fee) * totalPassengers;
        updatedFare += totalServiceFee;
      } else if (selectedAdminMarkup.service_type === "percentage") {
        const percentageFee =
          (baseFare * parseFloat(selectedAdminMarkup.service_fee)) / 100;
        updatedFare += percentageFee;
      }
    }

    return parseInt(updatedFare);
  };

  const calculateFare = (baseFare, markups, totalPassengers, flightCode) => {
    const flightType = isinternational ? "international" : "domestic";

    const applicableAgentMarkups =
      markups?.agent?.filter((markup) => markup.flight_type === flightType) ||
      [];

    const applicableAdminMarkups =
      markups?.admin?.filter((markup) => markup.flight_type === flightType) ||
      [];

    if (
      applicableAgentMarkups.length === 0 &&
      applicableAdminMarkups.length === 0
    ) {
      console.warn(
        `No applicable markups found for flight type: ${flightType}`
      );
      return baseFare;
    }

    const airlineWiseAgentMarkup = applicableAgentMarkups.find(
      (markup) =>
        markup.markup_type === "airline_wise" &&
        markup.flight_code === flightCode
    );

    const airlineWiseAdminMarkup = applicableAdminMarkups.find(
      (markup) =>
        markup.markup_type === "airline_wise" &&
        markup.flight_code === flightCode
    );

    const generalAgentMarkup = applicableAgentMarkups.find(
      (markup) => markup.markup_type === "all"
    );

    const generalAdminMarkup = applicableAdminMarkups.find(
      (markup) => markup.markup_type === "all"
    );

    const selectedAgentMarkup = airlineWiseAgentMarkup || generalAgentMarkup;
    const selectedAdminMarkup = airlineWiseAdminMarkup || generalAdminMarkup;

    let updatedFare = baseFare;

    if (selectedAgentMarkup) {
      if (selectedAgentMarkup.service_type === "fixed") {
        const totalServiceFee =
          parseFloat(selectedAgentMarkup.service_fee) * totalPassengers;
        updatedFare += totalServiceFee;
      } else if (selectedAgentMarkup.service_type === "percentage") {
        const percentageFee =
          (baseFare * parseFloat(selectedAgentMarkup.service_fee)) / 100;
        updatedFare += percentageFee;
      }
    }

    if (selectedAdminMarkup) {
      if (selectedAdminMarkup.service_type === "fixed") {
        const totalServiceFee =
          parseFloat(selectedAdminMarkup.service_fee) * totalPassengers;
        updatedFare += totalServiceFee;
      } else if (selectedAdminMarkup.service_type === "percentage") {
        const percentageFee =
          (baseFare * parseFloat(selectedAdminMarkup.service_fee)) / 100;
        updatedFare += percentageFee;
      }
    }

    return parseInt(updatedFare);
  };
  const calculateFares = (baseFare, markups, totalPassengers, flightCode) => {
    const flightType = isinternational ? "international" : "domestic";

    // Find applicable agent and admin markups
    const applicableAgentMarkups =
      markups.agent?.filter((markup) => markup.flight_type === flightType) ||
      [];

    const applicableAdminMarkups =
      markups.admin?.filter((markup) => markup.flight_type === flightType) ||
      [];

    // Find airline-specific and general markups
    const airlineWiseAgentMarkup = applicableAgentMarkups.find(
      (markup) =>
        markup.markup_type === "airline_wise" &&
        markup.flight_code === flightCode
    );

    const airlineWiseAdminMarkup = applicableAdminMarkups.find(
      (markup) =>
        markup.markup_type === "airline_wise" &&
        markup.flight_code === flightCode
    );

    const generalAgentMarkup = applicableAgentMarkups.find(
      (markup) => markup.markup_type === "all"
    );

    const generalAdminMarkup = applicableAdminMarkups.find(
      (markup) => markup.markup_type === "all"
    );

    // Prioritize airline-wise markup, then general markup
    const selectedAgentMarkup = airlineWiseAgentMarkup || generalAgentMarkup;
    const selectedAdminMarkup = airlineWiseAdminMarkup || generalAdminMarkup;

    if (!selectedAgentMarkup && !selectedAdminMarkup) {
      console.warn(`No markup found for flight type: ${flightType}`);
      return baseFare; // No markup found, just return the base fare
    }

    let updatedFare = baseFare; // Keep the base fare unchanged initially

    // Apply agent markup if available
    if (selectedAgentMarkup) {
      if (selectedAgentMarkup.service_type === "fixed") {
        // If agent markup is fixed
        const totalServiceFee =
          parseFloat(selectedAgentMarkup.service_fee) * totalPassengers;
        updatedFare += totalServiceFee; // Add total service fee for all passengers
      } else if (selectedAgentMarkup.service_type === "percentage") {
        // If agent markup is percentage
        const percentageFee =
          (baseFare * parseFloat(selectedAgentMarkup.service_fee)) / 100;
        updatedFare += percentageFee; // Add percentage fee for all passengers
      }
    }

    // Apply admin markup if available
    if (selectedAdminMarkup) {
      if (selectedAdminMarkup.service_type === "fixed") {
        // If admin markup is fixed
        const totalServiceFee =
          parseFloat(selectedAdminMarkup.service_fee) * totalPassengers;
        updatedFare += totalServiceFee; // Add total service fee for all passengers
      } else if (selectedAdminMarkup.service_type === "percentage") {
        // If admin markup is percentage
        const percentageFee =
          (baseFare * parseFloat(selectedAdminMarkup.service_fee)) / 100;
        updatedFare += percentageFee; // Add percentage fee for all passengers
      }
    }

    return parseInt(updatedFare);
  };

  const calculateFareForTax = (
    baseFare,
    markups,
    totalPassengers,
    flightCode
  ) => {
    const flightType = isinternational ? "international" : "domestic";

    // Find applicable agent and admin markups
    const applicableAgentMarkups =
      markups.agent?.filter((markup) => markup.flight_type === flightType) ||
      [];

    const applicableAdminMarkups =
      markups.admin?.filter((markup) => markup.flight_type === flightType) ||
      [];

    // Find airline-specific and general markups
    const airlineWiseAgentMarkup = applicableAgentMarkups.find(
      (markup) =>
        markup.markup_type === "airline_wise" &&
        markup.flight_code === flightCode
    );

    const airlineWiseAdminMarkup = applicableAdminMarkups.find(
      (markup) =>
        markup.markup_type === "airline_wise" &&
        markup.flight_code === flightCode
    );

    const generalAgentMarkup = applicableAgentMarkups.find(
      (markup) => markup.markup_type === "all"
    );

    const generalAdminMarkup = applicableAdminMarkups.find(
      (markup) => markup.markup_type === "all"
    );

    // Prioritize airline-wise markup, then general markup
    const selectedAgentMarkup = airlineWiseAgentMarkup || generalAgentMarkup;
    const selectedAdminMarkup = airlineWiseAdminMarkup || generalAdminMarkup;

    if (!selectedAgentMarkup && !selectedAdminMarkup) {
      console.warn(`No markup found for flight type: ${flightType}`);
      return baseFare; // No markup found, just return the base fare
    }

    let updatedFare = baseFare; // Keep the base fare unchanged initially

    // Apply agent markup if available
    if (selectedAgentMarkup) {
      if (selectedAgentMarkup.service_type === "percentage") {
        // If agent markup is percentage
        const percentageFee =
          (baseFare * parseFloat(selectedAgentMarkup.service_fee)) / 100;
        updatedFare += percentageFee; // Add percentage fee for all passengers
      } else if (selectedAgentMarkup.service_type === "fixed") {
        // If agent markup is fixed, return the previous amount (baseFare)
        updatedFare = baseFare;
      }
    }

    // Apply admin markup if available
    if (selectedAdminMarkup) {
      if (selectedAdminMarkup.service_type === "percentage") {
        // If admin markup is percentage
        const percentageFee =
          (baseFare * parseFloat(selectedAdminMarkup.service_fee)) / 100;
        updatedFare += percentageFee; // Add percentage fee for all passengers
      } else if (selectedAdminMarkup.service_type === "fixed") {
        // If admin markup is fixed, return the previous amount (baseFare)
        updatedFare = baseFare;
      }
    }

    return parseInt(updatedFare);
  };

  const handleTicketBook = async () => {
    function generateUUID() {
      const timestamp = new Date().getTime().toString(16); // Convert timestamp to hexadecimal
      const randomChars =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
      let randomString = "";

      for (let i = 0; i < 8; i++) {
        randomString += randomChars.charAt(
          Math.floor(Math.random() * randomChars.length)
        );
      }

      return `${timestamp}-${randomString}`;
    }

    let isFirstAdult = true;

    const adultPassengers = formData.map((data, index) => {
      const isLeadPax = isFirstAdult;
      isFirstAdult = false;
      return {
        Title: data.title,
        FirstName: data.firstName,
        LastName: data.lastName,
        PaxType: 1,
        DateOfBirth: data.date,
        Gender: data.title.toLowerCase() === "mr" ? "M" : "F",
        PassportNo: data.passport || null,
        PassportExpiry: data.expirydate,
        ContryCode: data.nationality,
        ContactNo: walletDataa.Phone,
        Email: walletDataa.Email,
        SeatCode: "",
        BaggageCode: "",
        MealCode: "",
        PaxFare: {
          BaseFare: flight.PexFareDetails[0].BaseFare * 1.0 + 0.0,
          TaxFare: flight.PexFareDetails[0].TaxFare * 1.0,

          YQTax: flight.PexFareDetails[0].YQTax * 1.0,
          PriceBaggage: 0.0 * 1.0,
          PriceMeal: 0.0 * 1.0,
          PriceSeat: 0.0 * 1.0,
        },
        IsLeadPax: isLeadPax,
        TicketNumber: null,
      };
    });
    const adjustPaxFareForMultiplePassengers = (passenger) => {
      if (flight.PexFareDetails[0].TotPax > 1) {
        const divisor = flight.PexFareDetails[0].TotPax;
        const adjustedPaxFare = {
          BaseFare: flight.PexFareDetails[0].BaseFare / divisor,
          TaxFare: flight.PexFareDetails[0].TaxFare / divisor,

          YQTax: flight.PexFareDetails[0].YQTax / divisor,
          PriceBaggage: 0.0,
          PriceMeal: 0.0,
          PriceSeat: 0.0,
        };

        return {
          ...passenger,
          PaxFare: adjustedPaxFare,
        };
      } else {
        return passenger;
      }
    };

    let isChildAdult = true;
    const childPassengers = childData.map((data) => {
      const isLeadPax = isChildAdult;
      isChildAdult = false;
      return {
        Title:
          data.title === "Mr" || data.title === "Mrs" ? "Mstr" : data.title,
        FirstName: data.firstName,
        LastName: data.lastName,
        PaxType: 2,
        DateOfBirth: data.date,
        Gender: data.title.toLowerCase() === "mr" ? "M" : "F",
        PassportNo: data.passport || null,
        PassportExpiry: data.expirydate || null,
        ContryCode: data.nationality,
        ContactNo: walletDataa.Phone,
        Email: walletDataa.Email,
        SeatCode: "",
        BaggageCode: "",
        MealCode: "",
        PaxFare: {
          BaseFare: flight.PexFareDetails[1].BaseFare * 1.0,
          TaxFare: flight.PexFareDetails[1].TaxFare * 1.0,

          YQTax: flight.PexFareDetails[1].YQTax * 1.0,
          PriceBaggage: 0.0 * 1.0,
          PriceMeal: 0.0 * 1.0,
          PriceSeat: 0.0 * 1.0,
        },
        IsLeadPax: isLeadPax,
        TicketNumber: null,
      };
    });
    const adjustPaxFareForMultiplePassengersChild = (passenger) => {
      if (flight.PexFareDetails[1].TotPax > 1) {
        const divisor = flight.PexFareDetails[1].TotPax;
        const adjustedPaxFare = {
          BaseFare: flight.PexFareDetails[1].BaseFare / divisor,
          TaxFare: flight.PexFareDetails[1].TaxFare / divisor,

          YQTax: flight.PexFareDetails[1].YQTax / divisor,
          PriceBaggage: 0.0,
          PriceMeal: 0.0,
          PriceSeat: 0.0,
        };

        return {
          ...passenger,
          PaxFare: adjustedPaxFare,
        };
      } else {
        return passenger;
      }
    };

    let isInfantAdult = true;
    const infantPassengers = infant.map((data) => {
      const isLeadPax = isInfantAdult;
      isInfantAdult = false;
      return {
        Title:
          data.title === "Mr" || data.title === "Mrs" ? "Mstr" : data.title,
        FirstName: data.firstName,
        LastName: data.lastName,
        PaxType: 3,
        DateOfBirth: data.date,
        Gender: data.title.toLowerCase() === "mr" ? "M" : "F",
        PassportNo: data.passport,
        PassportExpiry: data.expirydate,
        ContryCode: data.nationality,
        ContactNo: walletDataa.Phone,
        Email: walletDataa.Email,
        SeatCode: "",
        BaggageCode: "",
        MealCode: "",
        PaxFare: {
          BaseFare: flight.PexFareDetails[2].BaseFare * 1.0,
          TaxFare: flight.PexFareDetails[2].TaxFare * 1.0,

          YQTax: flight.PexFareDetails[2].YQTax * 1.0,
          PriceBaggage: 0.0 * 1.0,
          PriceMeal: 0.0 * 1.0,
          PriceSeat: 0.0 * 1.0,
        },
        IsLeadPax: isLeadPax,
        TicketNumber: null,
      };
    });
    const adjustPaxFareForMultiplePassengersInfant = (passenger) => {
      if (flight.PexFareDetails[2].TotPax > 1) {
        const divisor = flight.PexFareDetails[2].TotPax;
        const adjustedPaxFare = {
          BaseFare: flight.PexFareDetails[2].BaseFare / divisor,
          TaxFare: flight.PexFareDetails[2].TaxFare / divisor,

          YQTax: flight.PexFareDetails[2].YQTax / divisor,
          PriceBaggage: 0.0,
          PriceMeal: 0.0,
          PriceSeat: 0.0,
        };

        return {
          ...passenger,
          PaxFare: adjustedPaxFare,
        };
      } else {
        return passenger;
      }
    };

    let preferenceIndex = 0; // Initialize a counter for the preference index

    const allPassengers = [
      ...adultPassengers.map((passenger) => {
        const adjustedPassenger = adjustPaxFareForMultiplePassengers(passenger);
        return {
          ...passenger,
          PaxFare: adjustedPassenger.PaxFare, // Update PaxFare with adjusted values
        };
      }),
      // ...adultPassengers.map((passenger) => {
      //   const mealPreference = passengerMealPreferences[preferenceIndex]
      //     ? [passengerMealPreferences[preferenceIndex]]
      //     : null;
      //   const baggagePreference = passengerBaggagePreferences[preferenceIndex]
      //     ? [passengerBaggagePreferences[preferenceIndex]]
      //     : null;
      //   const seatPreference = passengerSeatPreferences[preferenceIndex]
      //     ? [passengerSeatPreferences[preferenceIndex]]
      //     : null;
      //   preferenceIndex++;
      //   return {

      //   };
      // }),
      ...childPassengers.map((passenger) => {
        const adjustedPassenger =
          adjustPaxFareForMultiplePassengersChild(passenger);
        return {
          ...passenger,
          PaxFare: adjustedPassenger.PaxFare, // Update PaxFare with adjusted values
        };
      }),

      ...infantPassengers.map((passenger) => {
        const adjustedPassenger =
          adjustPaxFareForMultiplePassengersInfant(passenger);
        return {
          ...passenger,
          PaxFare: adjustedPassenger.PaxFare, // Update PaxFare with adjusted values
        };
      }),
    ];
    const deductData = {
      AgentEmail: walletData && walletData.Email,
      FlightAmount:
        decodedIndex2 !== "" && decodedIndex2 !== "undefined"
          ? `${
              flight.AirlineFare.NetFare +
              flight2.AirlineFare.NetFare +
              markup +
              markup +
              agentmarkup +
              agentmarkup
            }`
          : `${calculateFareDeduct(
              flight.AirlineFare.NetFare,
              markups,
              totalPassengers,
              flight.AirSegments[0].AirlineCode
            )}`,
    };
    const requestData = {
      // PreferredCurrency: null,
      // ResultIndex: decodedIndex,
      // APIToken: token,
      Id: walletData.Email,
      IsGSTMandatory: gstAllow,
      BookingKey: bookingKey,
      AgentId: walletData && walletData.Id,
      ContractId:
        decodedIndex2 !== "" && decodedIndex2 !== "undefined"
          ? `${parseInt(decodedIndex2)}^${parseInt(decodedIndex)}`
          : decodedIndex,
      Flightpassenger: allPassengers,
      APIGst: null,
      BookingId: generateUUID(),
      IsHoldRequest: false,
      AccountNo: "27",
    };
    console.log("requestData", requestData);

    const apiUrl = "https://admin.yatriservice.com/api/flightbooking";
    const deductUrl =
      "https://admin.yatriservice.com/api/deduct-wallet-balance";

    // try {
    //   setLoading(true)
    //   const data = await axios.post(apiUrl, requestData);

    //   if (data.data.success === true) {
    //     setLoading(false)
    //     console.log("LCC Flight ticket booked successfully:", data);

    //     const deductData = {
    //       AgentEmail: walletData && walletData.Email,
    //       FlightAmount:
    //         decodedIndex2 !== "" && decodedIndex2 !== "undefined"
    //           ? `${
    //               calculateTotalFareDeduct(flight.AirlineFare.NetFare, markup) +
    //               calculateTotalFareDeduct(flight2.AirlineFare.NetFare, markup)
    //             }`
    //           : `${calculateTotalFareDeduct(
    //               flight.AirlineFare.NetFare,
    //               markup
    //             )}`,
    //     };
    //     try {
    //       const response = await axios.post(deductUrl, deductData);
    //       console.log("DEDUCT AMT DATA", response.data.data.WalletBalalnce);

    //       localStorage.setItem(
    //         "walletBalance",
    //         response.data.data.WalletBalalnce
    //       );
    //       localStorage.setItem("CreditLimit", response.data.data.CreditLimit);
    //     } catch (deductError) {
    //       console.error(
    //         "An error occurred while deducting from the wallet:",
    //         deductError
    //       );
    //     }

    //     sessionStorage.setItem(
    //       "BookingIdd",
    //       parseInt(data.data.data.flightbook.BookingId)
    //     );
    //     sessionStorage.setItem(
    //       "AirlinePnr",
    //       data.data.data.flightbook.AirlinePnr
    //     );

    //     window.location.assign("/agent/flight-ticket");
    //   } else {
    //     console.log("LCC ERROR FOUND IN BOOKING", data.data.success);
    //     console.log("LCC ERROR FOUND IN BOOKING", data);
    //     setLoading(false)
    //   }
    // } catch (error) {
    //   console.error("An error occurred during the API call:", error);
    //   setLoading(false)
    // }

    try {
      setLoading(true);
      const deductData = {
        AgentEmail: walletData && walletData.Email,
        FlightAmount:
          decodedIndex2 !== "" && decodedIndex2 !== "undefined"
            ? `${
                calculateFareDeduct(
                  flight.AirlineFare.NetFare,
                  markups,
                  totalPassengers,
                  flight.AirSegments[0].AirlineCode
                ) +
                calculateFareDeduct(
                  flight2.AirlineFare.NetFare,
                  markups,
                  totalPassengers,
                  flight.AirSegments[0].AirlineCode
                )
              }`
            : `${calculateFareDeduct(
                flight.AirlineFare.NetFare,
                markups,
                totalPassengers,
                flight.AirSegments[0].AirlineCode
              )}`,
      };

      const deductResponse = await axios.post(deductUrl, deductData);
      console.log("Wallet deduction response:", deductResponse.data);

      if (deductResponse.data.success) {
        localStorage.setItem(
          "walletBalance",
          deductResponse.data.data.WalletBalalnce
        );
        localStorage.setItem(
          "CreditLimit",
          deductResponse.data.data.CreditLimit
        );

        try {
          const data = await axios.post(apiUrl, requestData);

          if (data.data.success === true) {
            console.log("LCC Flight ticket booked successfully:", data);

            sessionStorage.setItem(
              "BookingIdd",
              parseInt(data.data.data.flightbook.BookingId)
            );
            sessionStorage.setItem(
              "AirlinePnr",
              data.data.data.flightbook.AirlinePnr
            );
            setLoading(false);
            window.location.assign("/agent/flight-ticket");
          } else {
            console.log("LCC ERROR FOUND IN BOOKING:", data.data.success);
            console.log("LCC ERROR FOUND IN BOOKING:", data);
            setLoading(false);
            toast.error("An error occurred while booking the flight");
            window.location.assign("/agent/error");
            // window.location.assign("/agent/error");
          }
        } catch (bookingError) {
          toast.error("An error occurred while booking the flight");
          setLoading(false);
          window.location.assign("/agent/error");
          // window.location.assign("/agent/error");
        }
      } else {
        console.error(
          "Failed to deduct amount from wallet:",
          deductResponse.data
        );
        setLoading(false);
        window.location.assign("/agent/error");
        // window.location.assign("/agent/error");
      }
    } catch (deductError) {
      console.error(
        "An error occurred while deducting from the wallet:",
        deductError
      );
      setLoading(false);
      window.location.assign("/agent/error");
      // window.location.assign("/agent/error");
    }
  };
  const handleTicketBookRound = async () => {
    if (formData === null || formData === "" || formData.length === 0) {
      alert("Please fill the traveller information");
      return; // Exit the function early
    }
    function generateUUIDs() {
      const timestamp = new Date().getTime().toString(16); // Convert timestamp to hexadecimal
      const randomChars =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*";
      let randomString = "";

      for (let i = 0; i < 8; i++) {
        randomString += randomChars.charAt(
          Math.floor(Math.random() * randomChars.length)
        );
      }

      return `${timestamp}-${randomString}`;
    }

    let isFirstAdult = true;

    const adultPassengers = formData.map((data, index) => {
      const isLeadPax = isFirstAdult;
      isFirstAdult = false;
      return {
        Title: data.title,
        FirstName: data.firstName,
        LastName: data.lastName,
        PaxType: 1,
        DateOfBirth: "09-07-2006",
        Gender: data.title.toLowerCase() === "mr" ? "M" : "F",
        PassportNo: data.passport || null,
        PassportExpiry: data.expirydate || null,
        ContryCode: data.nationality,
        ContactNo: walletDataa.Phone,
        Email: walletDataa.Email,
        SeatCode: "",
        BaggageCode: "",
        MealCode: "",
        PaxFare: {
          BaseFare:
            flight.PexFareDetails[0].BaseFare +
            flight2.PexFareDetails[0].BaseFare +
            0.0,
          TaxFare:
            flight.PexFareDetails[0].TaxFare +
            flight2.PexFareDetails[0].TaxFare,

          YQTax:
            flight.PexFareDetails[0].YQTax + flight2.PexFareDetails[0].YQTax,
          PriceBaggage: 0.0,
          PriceMeal: 0.0,
          PriceSeat: 0.0,
        },
        IsLeadPax: isLeadPax,
        TicketNumber: null,
      };
    });

    const adjustPaxFareForMultiplePassengers = (passenger) => {
      if (flight.PexFareDetails[0].TotPax > 1) {
        const divisor = flight.PexFareDetails[0].TotPax;
        const adjustedPaxFare = {
          BaseFare:
            (flight.PexFareDetails[0].BaseFare +
              flight2.PexFareDetails[0].BaseFare) /
            divisor,
          TaxFare:
            (flight.PexFareDetails[0].TaxFare +
              flight2.PexFareDetails[0].TaxFare) /
            divisor,

          YQTax:
            (flight.PexFareDetails[0].YQTax + flight2.PexFareDetails[0].YQTax) /
            divisor,
          PriceBaggage: 0.0,
          PriceMeal: 0.0,
          PriceSeat: 0.0,
        };

        return {
          ...passenger,
          PaxFare: adjustedPaxFare,
        };
      } else {
        return passenger;
      }
    };
    let isChildAdult = true;
    const childPassengers = childData.map((data) => {
      const isLeadPax = isChildAdult;
      isChildAdult = false;
      return {
        Title:
          data.title === "Mr" || data.title === "Mrs" ? "Mstr" : data.title,
        FirstName: data.firstName,
        LastName: data.lastName,
        PaxType: 2,
        DateOfBirth: "8-07-2016",
        Gender: data.title.toLowerCase() === "mr" ? "M" : "F",
        PassportNo: data.passport || null,
        PassportExpiry: data.expirydate || null,
        ContryCode: data.nationality,
        ContactNo: walletDataa.Phone,
        Email: walletDataa.Email,
        SeatCode: "",
        BaggageCode: "",
        MealCode: "",
        PaxFare: {
          BaseFare:
            flight.PexFareDetails[1].BaseFare +
            flight2.PexFareDetails[1].BaseFare +
            0.0,
          TaxFare:
            flight.PexFareDetails[1].TaxFare +
            flight2.PexFareDetails[1].TaxFare,

          YQTax:
            flight.PexFareDetails[1].YQTax + flight2.PexFareDetails[1].YQTax,
          PriceBaggage: 0.0 * 1.0,
          PriceMeal: 0.0 * 1.0,
          PriceSeat: 0.0 * 1.0,
        },
        IsLeadPax: isLeadPax,
        TicketNumber: null,
      };
    });
    const adjustPaxFareForMultiplePassengersChild = (passenger) => {
      if (flight.PexFareDetails[1].TotPax > 1) {
        const divisor = flight.PexFareDetails[1].TotPax;
        const adjustedPaxFare = {
          BaseFare:
            (flight.PexFareDetails[1].BaseFare +
              flight2.PexFareDetails[1].BaseFare) /
            divisor,
          TaxFare:
            (flight.PexFareDetails[1].TaxFare +
              flight2.PexFareDetails[1].TaxFare) /
            divisor,

          YQTax:
            (flight.PexFareDetails[1].YQTax + flight2.PexFareDetails[1].YQTax) /
            divisor,
          PriceBaggage: 0.0,
          PriceMeal: 0.0,
          PriceSeat: 0.0,
        };

        return {
          ...passenger,
          PaxFare: adjustedPaxFare,
        };
      } else {
        return passenger;
      }
    };
    let isInfantAdult = true;
    const infantPassengers = infant.map((data) => {
      const isLeadPax = isInfantAdult;
      isInfantAdult = false;
      return {
        Title:
          data.title === "Mr" || data.title === "Mrs" ? "Mstr" : data.title,
        FirstName: data.firstName,
        LastName: data.lastName,
        PaxType: 3,
        DateOfBirth: "17-05-2002",
        Gender: data.title.toLowerCase() === "mr" ? "M" : "F",
        PassportNo: data.passport || null,
        PassportExpiry: data.expirydate || null,
        ContryCode: data.nationality,
        ContactNo: walletDataa.Phone,
        Email: walletDataa.Email,
        SeatCode: "",
        BaggageCode: "",
        MealCode: "",
        PaxFare: {
          BaseFare:
            flight.PexFareDetails[2].BaseFare +
            flight2.PexFareDetails[2].BaseFare +
            0.0,
          TaxFare:
            flight.PexFareDetails[2].TaxFare +
            flight2.PexFareDetails[2].TaxFare,

          YQTax:
            flight.PexFareDetails[2].YQTax + flight2.PexFareDetails[2].YQTax,
          PriceBaggage: 0.0 * 1.0,
          PriceMeal: 0.0 * 1.0,
          PriceSeat: 0.0 * 1.0,
        },
        IsLeadPax: isLeadPax,
        TicketNumber: null,
      };
    });
    const adjustPaxFareForMultiplePassengersInfant = (passenger) => {
      if (flight.PexFareDetails[2].TotPax > 1) {
        const divisor = flight.PexFareDetails[2].TotPax;
        const adjustedPaxFare = {
          BaseFare:
            (flight.PexFareDetails[2].BaseFare +
              flight2.PexFareDetails[2].BaseFare) /
            divisor,
          TaxFare:
            (flight.PexFareDetails[2].TaxFare +
              flight2.PexFareDetails[2].TaxFare) /
            divisor,

          YQTax:
            (flight.PexFareDetails[2].YQTax + flight2.PexFareDetails[2].YQTax) /
            divisor,
          PriceBaggage: 0.0,
          PriceMeal: 0.0,
          PriceSeat: 0.0,
        };

        return {
          ...passenger,
          PaxFare: adjustedPaxFare,
        };
      } else {
        return passenger;
      }
    };
    let preferenceIndex = 0; // Initialize a counter for the preference index

    const allPassengers = [
      ...adultPassengers.map((passenger) => {
        const adjustedPassenger = adjustPaxFareForMultiplePassengers(passenger);
        return {
          ...passenger,
          PaxFare: adjustedPassenger.PaxFare, // Update PaxFare with adjusted values
        };
      }),
      // ...adultPassengers.map((passenger) => {
      //   const mealPreference = passengerMealPreferences[preferenceIndex]
      //     ? [passengerMealPreferences[preferenceIndex]]
      //     : null;
      //   const baggagePreference = passengerBaggagePreferences[preferenceIndex]
      //     ? [passengerBaggagePreferences[preferenceIndex]]
      //     : null;
      //   const seatPreference = passengerSeatPreferences[preferenceIndex]
      //     ? [passengerSeatPreferences[preferenceIndex]]
      //     : null;
      //   preferenceIndex++;
      //   return {
      //     ...passenger,
      //   };
      // }),
      ...childPassengers.map((passenger) => {
        const adjustedPassenger =
          adjustPaxFareForMultiplePassengersChild(passenger);
        return {
          ...passenger,
          PaxFare: adjustedPassenger.PaxFare, // Update PaxFare with adjusted values
        };
      }),
      ...infantPassengers.map((passenger) => {
        const adjustedPassenger =
          adjustPaxFareForMultiplePassengersInfant(passenger);
        return {
          ...passenger,
          PaxFare: adjustedPassenger.PaxFare, // Update PaxFare with adjusted values
        };
      }),
    ];

    const requestData = {
      // PreferredCurrency: null,
      // ResultIndex: decodedIndex,
      // APIToken: token,
      Id: walletData.Email,
      BookingKey: bookingKey,
      IsGSTMandatory: gstAllow,
      AgentId: walletData && walletData.Id,
      ContractId:
        decodedIndex2 !== "" && decodedIndex2 !== "undefined"
          ? `${parseInt(decodedIndex)}^${parseInt(decodedIndex2)}`
          : decodedIndex,
      Flightpassenger: allPassengers,
      BookingId: generateUUIDs(),
      APIGst: null,
      IsHoldRequest: false,
      AccountNo: "27",
    };
    // const deductData = {
    //   AgentEmail: walletData && walletData.Email,
    //   FlightAmount:
    //     decodedIndex2 !== "" && decodedIndex2 !== "undefined"
    //       ? `${
    //           flight.AirlineFare.NetFare +
    //           flight2.AirlineFare.NetFare +
    //           markup +
    //           markup
    //         }`
    //       : `${flight.AirlineFare.NetFare + markup }`,
    // };
    console.log("requestData", requestData);

    // Make the API call
    const apiUrl = "https://admin.yatriservice.com/api/flightbooking";
    const deductUrl =
      "https://admin.yatriservice.com/api/deduct-wallet-balance";
    // flight &&
    //   flight.IsLCC &&

    // const data = await axios.post(apiUrl, requestData);
    // if (data.data.success === "true") {
    //   console.log("LCC Flight ticket booked successfully:", data);

    //   const respons = await axios.post(deductUrl, deductData);
    //   if (respons) {
    //     console.log("DEDUCT AMT DATA", respons.data.data.WalletBalalnce);
    //     localStorage.setItem("walletBalance", respons.data.data.WalletBalalnce);
    //   }
    //   sessionStorage.setItem(
    //     "BookingIdd",
    //     parseInt(data.data.data.flightbook.BookingId)
    //   );
    //   sessionStorage.setItem(
    //     "AirlinePnr",
    //     data.data.data.flightbook.AirlinePnr
    //   );
    //   window.location.assign("/agent/flight-ticket");
    // } else {
    //   console.log("LCC ERROR FOUND IN BOOKING",data);
    // }
    // try {
    //   setLoading(true)

    //   const bookingResponse = await axios.post(apiUrl, requestData);

    //   if (bookingResponse.data.success === true) {
    //     setLoading(false)

    //     console.log("LCC Flight ticket booked successfully:", bookingResponse);

    //     const deductData = {
    //       AgentEmail: walletData && walletData.Email,
    //       FlightAmount:
    //         decodedIndex2 !== "" && decodedIndex2 !== "undefined"
    //           ? `${
    //               calculateTotalFareDeduct(flight.AirlineFare.NetFare, markup) +
    //               calculateTotalFareDeduct(flight2.AirlineFare.NetFare, markup)
    //             }`
    //           : `${calculateTotalFareDeduct(
    //               flight.AirlineFare.NetFare,
    //               markup
    //             )}`,
    //     };

    //     const deductionResponse = await axios.post(deductUrl, deductData);

    //     if (
    //       deductionResponse &&
    //       deductionResponse.data &&
    //       deductionResponse.data.data
    //     ) {
    //       console.log(
    //         "DEDUCT AMT DATA",
    //         deductionResponse.data.data.WalletBalalnce
    //       );

    //       localStorage.setItem(
    //         "walletBalance",
    //         deductionResponse.data.data.WalletBalalnce
    //       );
    //       localStorage.setItem(
    //         "CreditLimit",
    //         deductionResponse.data.data.CreditLimit
    //       );
    //     } else {
    //       console.error(
    //         "Unexpected deduction response format:",
    //         deductionResponse
    //       );
    //     }

    //     sessionStorage.setItem(
    //       "BookingIdd",
    //       parseInt(bookingResponse.data.data.flightbook.BookingId, 10)
    //     );
    //     sessionStorage.setItem(
    //       "AirlinePnr",
    //       bookingResponse.data.data.flightbook.AirlinePnr
    //     );

    //     window.location.assign("/agent/flight-ticket");
    //   } else {
    //     console.log("LCC ERROR FOUND IN BOOKING", bookingResponse);
    //     setLoading(false)
    //   }
    // } catch (error) {

    //   console.error("An error occurred:", error);
    //   setLoading(false)
    // }

    try {
      setLoading(true);

      // Prepare deduction data
      const deductData = {
        AgentEmail: walletData && walletData.Email,
        FlightAmount:
          decodedIndex2 !== "" && decodedIndex2 !== "undefined"
            ? `${
                calculateFareDeduct(
                  flight.AirlineFare.NetFare,
                  markups,
                  totalPassengers,
                  flight.AirSegments[0].AirlineCode
                ) +
                calculateFareDeduct(
                  flight2.AirlineFare.NetFare,
                  markups,
                  totalPassengers,
                  flight2.AirSegments[0].AirlineCode
                )
              }`
            : `${calculateFareDeduct(
                flight.AirlineFare.NetFare,
                markups,
                totalPassengers,
                flight.AirSegments[0].AirlineCode
              )}`,
      };

      const deductResponse = await axios.post(deductUrl, deductData);
      console.log("Wallet deduction response:", deductResponse.data);

      if (deductResponse.data.success) {
        localStorage.setItem(
          "walletBalance",
          deductResponse.data.data.WalletBalalnce
        );
        localStorage.setItem(
          "CreditLimit",
          deductResponse.data.data.CreditLimit
        );

        // Proceed with booking after successful deduction
        try {
          const bookingResponse = await axios.post(apiUrl, requestData);

          if (bookingResponse.data.success === true) {
            setLoading(false);
            console.log(
              "LCC Flight ticket booked successfully:",
              bookingResponse
            );

            sessionStorage.setItem(
              "BookingIdd",
              parseInt(bookingResponse.data.data.flightbook.BookingId, 10)
            );
            sessionStorage.setItem(
              "AirlinePnr",
              bookingResponse.data.data.flightbook.AirlinePnr
            );

            // Redirect to the flight ticket page
            window.location.assign("/agent/flight-ticket");
          } else {
            console.log(
              "LCC ERROR FOUND IN BOOKING:",
              bookingResponse.data.success
            );
            toast.error("An error occurred while booking the flight");
            console.log("LCC ERROR FOUND IN BOOKING:", bookingResponse);
            setLoading(false);
            // window.location.assign("/agent/error");
            window.location.assign("/agent/error");
          }
        } catch (bookingError) {
          toast.error("An error occurred while booking the flight");
          setLoading(false);
          // window.location.assign("/agent/error");
          window.location.assign("/agent/error");
        }
      } else {
        console.error(
          "Failed to deduct amount from wallet:",
          deductResponse.data
        );
        setLoading(false);
        // window.location.assign("/agent/error");
        window.location.assign("/agent/error");
      }
    } catch (deductError) {
      console.error(
        "An error occurred while deducting from the wallet:",
        deductError
      );
      setLoading(false);
      // window.location.assign("/agent/error");
      window.location.assign("/agent/error");
    }
  };
  // const handleTicketBookRound = () => {
  //   let isFirstAdult = true;

  //   const adultPassengers = formData.map((data, index) => {
  //     const isLeadPax = isFirstAdult;
  //     isFirstAdult = false;
  //     return {
  //       Title: data.title,
  //       FirstName: data.firstName,
  //       LastName: data.lastName,
  //       PaxType: 1,
  //       DateOfBirth: "1987-12-06T00:00:00",
  //       Gender: data.title.toLowerCase() === "mr" ? 1 : 2,

  //       AddressLine1: "123, Test",
  //       Fare: {
  //         Currency: flight2.FareBreakdown[0].Currency,
  //         BaseFare: flight2.FareBreakdown[0].BaseFare,
  //         Tax: flight2.FareBreakdown[0].Tax,
  //         TaxBreakup: flight2.FareBreakdown[0].TaxBreakup,
  //         YQTax: flight2.FareBreakdown[0].YQTax,
  //         AdditionalTxnFeeOfrd: flight2.FareBreakdown[0].AdditionalTxnFeeOfrd,
  //         AdditionalTxnFeePub: flight2.FareBreakdown[0].AdditionalTxnFeePub,
  //         PGCharge: flight2.FareBreakdown[0].PGCharge,
  //         OtherCharges: flight2.Fare.OtherCharges,
  //         ChargeBU: flight2.Fare.ChargeBU,
  //         Discount: flight2.Fare.Discount,
  //         PublishedFare: flight2.Fare.PublishedFare,
  //         CommissionEarned: flight2.Fare.CommissionEarned,
  //         PLBEarned: flight2.Fare.PLBEarned,
  //         IncentiveEarned: flight2.Fare.IncentiveEarned,
  //         OfferedFare: flight2.Fare.OfferedFare,
  //         TdsOnCommission: flight2.Fare.TdsOnCommission,
  //         TdsOnPLB: flight2.Fare.TdsOnPLB,
  //         TdsOnIncentive: flight2.Fare.TdsOnIncentive,
  //         ServiceFee: flight2.Fare.ServiceFee,
  //         TotalBaggageCharges: flight2.Fare.TotalBaggageCharges,
  //         TotalMealCharges: flight2.Fare.TotalMealCharges,
  //         TotalSeatCharges: flight2.Fare.TotalSeatCharges,
  //         TotalSpecialServiceCharges: flight2.Fare.TotalSpecialServiceCharges,
  //       },
  //       City: "Gurgaon",
  //       CountryCode: "IN",
  //       CountryName: "India",
  //       Nationality: "IN",
  //       ContactNo: "9879879877",
  //       Email: "harsh@tbtq.in",
  //       IsLeadPax: isLeadPax,

  //       GSTCompanyAddress: "",
  //       GSTCompanyContactNumber: "",
  //       GSTCompanyName: "",
  //       GSTNumber: "",
  //       GSTCompanyEmail: "",
  //     };
  //   });

  //   const childPassengers = childData.map((data) => ({
  //     Title: data.title,
  //     FirstName: data.firstName,
  //     LastName: data.lastName,
  //     PaxType: 2,
  //     DateOfBirth: "2017-12-06T00:00:00",
  //     Gender: data.title.toLowerCase() === "mr" ? 1 : 2,

  //     AddressLine1: "123, Test",
  //     Fare: {
  //       Currency: flight2.FareBreakdown[1].Currency,
  //       BaseFare: flight2.FareBreakdown[1].BaseFare,
  //       Tax: flight2.FareBreakdown[1].Tax,
  //       TaxBreakup: flight2.FareBreakdown[1].TaxBreakup,
  //       YQTax: flight2.FareBreakdown[1].YQTax,
  //       AdditionalTxnFeeOfrd: flight2.FareBreakdown[1].AdditionalTxnFeeOfrd,
  //       AdditionalTxnFeePub: flight2.FareBreakdown[1].AdditionalTxnFeePub,
  //       PGCharge: flight2.FareBreakdown[1].PGCharge,
  //       OtherCharges: flight2.Fare.OtherCharges,
  //       ChargeBU: flight2.Fare.ChargeBU,
  //       Discount: flight2.Fare.Discount,
  //       PublishedFare: flight2.Fare.PublishedFare,
  //       CommissionEarned: flight2.Fare.CommissionEarned,
  //       PLBEarned: flight2.Fare.PLBEarned,
  //       IncentiveEarned: flight2.Fare.IncentiveEarned,
  //       OfferedFare: flight2.Fare.OfferedFare,
  //       TdsOnCommission: flight2.Fare.TdsOnCommission,
  //       TdsOnPLB: flight2.Fare.TdsOnPLB,
  //       TdsOnIncentive: flight2.Fare.TdsOnIncentive,
  //       ServiceFee: flight2.Fare.ServiceFee,
  //       TotalBaggageCharges: flight2.Fare.TotalBaggageCharges,
  //       TotalMealCharges: flight2.Fare.TotalMealCharges,
  //       TotalSeatCharges: flight2.Fare.TotalSeatCharges,
  //       TotalSpecialServiceCharges: flight2.Fare.TotalSpecialServiceCharges,
  //     },
  //     City: "Gurgaon",
  //     CountryCode: "IN",
  //     CountryName: "India",
  //     Nationality: "IN",
  //     ContactNo: "9879879877",
  //     Email: "harsh@tbtq.in",
  //     IsLeadPax: false,

  //     GSTCompanyAddress: "",
  //     GSTCompanyContactNumber: "",
  //     GSTCompanyName: "",
  //     GSTNumber: "",
  //     GSTCompanyEmail: "",
  //   }));

  //   const infantPassengers = infant.map((data) => ({
  //     Title: data.title,
  //     FirstName: data.firstName,
  //     LastName: data.lastName,
  //     PaxType: 3,
  //     DateOfBirth: "2023-12-06T00:00:00",
  //     Gender: data.title.toLowerCase() === "mr" ? 1 : 2,

  //     AddressLine1: "123, Test",
  //     Fare: {
  //       Currency: flight2.FareBreakdown[2].Currency,
  //       BaseFare: flight2.FareBreakdown[2].BaseFare,
  //       Tax: flight2.FareBreakdown[2].Tax,
  //       TaxBreakup: flight2.FareBreakdown[2].TaxBreakup,
  //       YQTax: flight2.FareBreakdown[2].YQTax,
  //       AdditionalTxnFeeOfrd: flight2.FareBreakdown[2].AdditionalTxnFeeOfrd,
  //       AdditionalTxnFeePub: flight2.FareBreakdown[2].AdditionalTxnFeePub,
  //       PGCharge: flight2.FareBreakdown[2].PGCharge,
  //       OtherCharges: flight2.Fare.OtherCharges,
  //       ChargeBU: flight2.Fare.ChargeBU,
  //       Discount: flight2.Fare.Discount,
  //       PublishedFare: flight2.Fare.PublishedFare,
  //       CommissionEarned: flight2.Fare.CommissionEarned,
  //       PLBEarned: flight2.Fare.PLBEarned,
  //       IncentiveEarned: flight2.Fare.IncentiveEarned,
  //       OfferedFare: flight2.Fare.OfferedFare,
  //       TdsOnCommission: flight2.Fare.TdsOnCommission,
  //       TdsOnPLB: flight2.Fare.TdsOnPLB,
  //       TdsOnIncentive: flight2.Fare.TdsOnIncentive,
  //       ServiceFee: flight2.Fare.ServiceFee,
  //       TotalBaggageCharges: flight2.Fare.TotalBaggageCharges,
  //       TotalMealCharges: flight2.Fare.TotalMealCharges,
  //       TotalSeatCharges: flight2.Fare.TotalSeatCharges,
  //       TotalSpecialServiceCharges: flight2.Fare.TotalSpecialServiceCharges,
  //     },
  //     City: "Gurgaon",
  //     CountryCode: "IN",
  //     CountryName: "India",
  //     Nationality: "IN",
  //     ContactNo: "9879879877",
  //     Email: "harsh@tbtq.in",
  //     IsLeadPax: false,

  //     GSTCompanyAddress: "",
  //     GSTCompanyContactNumber: "",
  //     GSTCompanyName: "",
  //     GSTNumber: "",
  //     GSTCompanyEmail: "",
  //   }));

  //   const allPassengers = [
  //     ...adultPassengers,
  //     ...childPassengers,
  //     ...infantPassengers,
  //   ];

  //   const requestData = {
  //     PreferredCurrency: null,
  //     ResultIndex: decodedIndex2,
  //     Passengers: allPassengers,
  //     EndUserIp: "192.168.11.58",
  //     TokenId: token,
  //     TraceId: traceId,
  //     GSTCompanyAddress:
  //       "A2, Palam-Dabri Road, Mahavir Enclave, Dwarka, New Delhi, India",
  //     GSTCompanyContactNumber: "9015858565",
  //     GSTCompanyName: "eWeblink Technology LLP",
  //     GSTNumber: "07AAFFE6846H1Z9",
  //     GSTCompanyEmail: "info@eweblink.net",
  //   };
  //   console.log("requestData2", requestData);

  //   const apiUrl = flight2.IsLCC
  //     ? "https://admin.yatriservice.com/api/flight-ticket"
  //     : "https://admin.yatriservice.com/api/flight-book";

  //   fetch(apiUrl, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(requestData),
  //   })
  //     .then((response) => {
  //       if (!response.ok) {
  //         navigate("/agent/404");
  //         throw new Error("Network response was not ok");
  //       }
  //       return response.json();
  //     })
  //     .then((data2) => {

  //       console.log("LCC flight2 ticket booked successfully:", data2);
  //       if (!data2.success) {
  //         navigate("/agent/404");
  //       }
  //       sessionStorage.setItem(
  //         "BookingId2",
  //         JSON.stringify(data2.data.Response.BookingId)
  //       );
  //       sessionStorage.setItem("PNR2", JSON.stringify(data2.data.Response.PNR));
  //       sessionStorage.setItem(
  //         "FirstName2",
  //         data2.data.Response.FlightItinerary.Passenger[0].FirstName
  //       );
  //       sessionStorage.setItem(
  //         "LastName2",
  //         data2.data.Response.FlightItinerary.Passenger[0].LastName
  //       );

  //       if (!flight2.IsLCC && data2.success) {

  //         const { PNR, BookingId } = data2.data.Response;

  //         fetch("https://admin.yatriservice.com/api/flight-ticket", {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({
  //             EndUserIp: "192.168.10.10",
  //             TokenId: token,
  //             TraceId: requestData.TraceId,
  //             BookingId,
  //             PNR,
  //           }),
  //         })
  //           .then((ticketResponse) => ticketResponse.json())
  //           .then((ticketData) => {

  //             console.log("LCC flight2 ticket data:", ticketData);
  //           })
  //           .catch((error) => {

  //             console.error(
  //               "Error while fetching NonLCC flight2 ticket:",
  //               error
  //             );
  //             navigate("/agent/404");
  //           });
  //       }

  //       navigate("/agent/flight-ticket");
  //     })
  //     .catch((error) => {

  //       console.error("Error while booking LCC flight2 ticket:", error);
  //       navigate("/agent/404");
  //     });
  // };

  const [walletDataa, setWalletDataa] = useState({
    Phone: walletData.Phone,
    Email: walletData.Email,
  });

  const handleDataUpdate = (updatedData) => {
    setWalletDataa((prevData) => ({
      ...prevData,
      ...updatedData,
    }));
  };

  const handleChangeFlight = () => {
    navigate(-1);
  };

  // const validatePassengerData = () => {
  //   // Define the required fields for each passenger type
  //   const requiredFields = ["title", "firstName", "lastName"];
  //   // const passportFields = ["passport", "issuedate", "expirydate"];

  //   // Check if passport details are mandatory
  //   // const isPassportMandatory =
  //   //   flight.PricedItinerary.IsPassportIssueDateMandatory ||
  //   //   flight.PricedItinerary.IsPassportMandatory ||
  //   //   flight.PricedItinerary.IsPassportNameWithSpace;

  //   // Helper function to check if an object has all required fields filled
  //   const isValid = (data, index, type) => {
  //     for (const field of requiredFields) {
  //       if (!data[field] || data[field].trim() === "") {
  //         alert(`Please fill out the ${field} for ${type} ${index + 1}`);
  //         return false;
  //       }
  //     }
  //     // Check for passport fields if they are mandatory
  //     // if (isPassportMandatory) {
  //     //   for (const field of passportFields) {
  //     //     if (!data[field] || data[field].trim() === "") {
  //     //       alert(`Please fill out the ${field} for ${type} ${index + 1}`);
  //     //       return false;
  //     //     }
  //     //   }
  //     // }
  //     return true;
  //   };

  //   // Check if data is present for all passengers
  //   const adultCount = flight && flight.PexFareDetails[0].TotPax;
  //   const childCount = flight.PexFareDetails[1]
  //     ? flight.PexFareDetails[1].TotPax
  //     : 0;

  //   const infantCount = flight.PexFareDetails[2]
  //     ? flight.PexFareDetails[2].TotPax
  //     : 0;

  //   // Validate adult data
  //   if (formData.length !== adultCount) {
  //     alert(`Please fill out details for all ${adultCount} adults`);
  //     return false;
  //   }
  //   for (let i = 0; i < formData.length; i++) {
  //     if (!isValid(formData[i], i, "adult")) return false;
  //   }

  //   // Validate child data
  //   if (childData.length !== childCount) {
  //     alert(`Please fill out details for all ${childCount} children`);
  //     return false;
  //   }
  //   for (let i = 0; i < childData.length; i++) {
  //     if (!isValid(childData[i], i, "child")) return false;
  //   }

  //   // Validate infant data
  //   if (infant.length !== infantCount) {
  //     alert(`Please fill out details for all ${infantCount} infants`);
  //     return false;
  //   }
  //   for (let i = 0; i < infant.length; i++) {
  //     if (!isValid(infant[i], i, "infant")) return false;
  //   }

  //   return true;
  // };

  const validatePassengerData = () => {
    const requiredFields = ["title", "firstName", "lastName"];
    const passportFields = ["passport", "expirydate"];
    const dobField = "date";

    const isInternationals = isinternational === true;

    const calculateAge = (dobStr) => {
      const today = new Date();
      const dob = new Date(dobStr);
      let age = today.getFullYear() - dob.getFullYear();
      const m = today.getMonth() - dob.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
        age--;
      }
      return age;
    };

    const isPassportExpiryValid = (expiryDateStr) => {
      const expiryDate = new Date(expiryDateStr);
      const today = new Date();
      const sixMonthsLater = new Date();
      sixMonthsLater.setMonth(today.getMonth() + 6);
      return expiryDate > sixMonthsLater;
    };

    const isValid = (data, index, type) => {
      // Check required fields
      for (const field of requiredFields) {
        if (!data[field] || data[field].trim() === "") {
          toast.error(`Please fill out the ${field} for ${type} ${index + 1}`);
          return false;
        }
      }

      // Date of Birth logic
      const dobRequired =
        isInternationals || type === "child" || type === "infant";

      if (dobRequired) {
        const dobValue = data[dobField];

        if (!dobValue) {
          toast.error(`Please provide Date of Birth for ${type} ${index + 1}`);
          return false;
        }

        const dobDate = new Date(dobValue);
        if (isNaN(dobDate.getTime())) {
          toast.error(`Invalid Date of Birth format for ${type} ${index + 1}`);
          return false;
        }

        const age = calculateAge(dobValue);
        if (type === "infant" && age >= 2) {
          toast.error(`Infant ${index + 1} must be under 2 years old`);
          return false;
        } else if (type === "child" && (age < 2 || age >= 12)) {
          toast.error(`Child ${index + 1} must be between 2 and 12 years old`);
          return false;
        } else if (type === "adult" && age < 12) {
          toast.error(`Adult ${index + 1} must be at least 12 years old`);
          return false;
        }
      }

      // Passport validation (only for international)
      if (isInternationals) {
        for (const field of passportFields) {
          if (!data[field] || data[field].trim() === "") {
            toast.error(`Please fill out the ${field} for ${type} ${index + 1}`);
            return false;
          }
        }

        // if (!isPassportExpiryValid(data.expirydate)) {
        //   toast.error(
        //     `Passport for ${type} ${
        //       index + 1
        //     } must be valid for at least 6 more months`
        //   );
        //   return false;
        // }
      }

      return true;
    };

    const adultCount = flight?.PexFareDetails?.[0]?.TotPax || 0;
    const childCount = flight?.PexFareDetails?.[1]?.TotPax || 0;
    const infantCount = flight?.PexFareDetails?.[2]?.TotPax || 0;

    if (formData.length !== adultCount) {
      alert(`Please fill out details for all ${adultCount} adults`);
      return false;
    }
    for (let i = 0; i < formData.length; i++) {
      if (!isValid(formData[i], i, "adult")) return false;
    }

    if (childData.length !== childCount) {
      alert(`Please fill out details for all ${childCount} children`);
      return false;
    }
    for (let i = 0; i < childData.length; i++) {
      if (!isValid(childData[i], i, "child")) return false;
    }

    if (infant.length !== infantCount) {
      alert(`Please fill out details for all ${infantCount} infants`);
      return false;
    }
    for (let i = 0; i < infant.length; i++) {
      if (!isValid(infant[i], i, "infant")) return false;
    }

    return true;
  };

  console.log("flightttttttttttt", flight);
  console.log("flight1", flight);
  console.log("flight2", flight2);
  const calculateTotalFare = (response, markup, agentmarkup) => {
    const PexFareDetailss = (flight && flight?.PexFareDetails) || [];

    // Calculate total passengers (TotPax)
    const totalPax = PexFareDetailss.reduce(
      (sum, detail) => sum + (detail.TotPax || 0),
      0
    );
    const totalFare = response + markup * totalPax + agentmarkup * totalPax;

    return totalFare;
  };

  console.log("isInternational", isinternational);
  console.log("internationalMarkup", InternationalMarkup);

  const [showModal, setShowModal] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const handleShowModal = () => {
    // Show the modal when the "Pay Now" button is clicked
    setShowModal(true);
    setOpenPayBtn(false);
  };

  const handleConfirmModal = () => {
    // After confirming in the modal, set the Pay button to true
    setOpenPayBtn(true);
    handleCloseModal(); // Close the modal
  };
  // Function to open the modal when the button is clicked
  // const handleShowModal = () => {
  //   setShowModal(true);
  // };

  // // Function to confirm the payment and proceed with the booking
  // const handleConfirmBooking = () => {
  //   setConfirmed(true);
  //   // Call the booking logic here (e.g., handleTicketBook)
  //   handleTicketBook();
  //   setShowModal(false);
  // };

  // Function to close the modal if the user cancels
  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className="roundtrippg">
      <div style={{ position: "relative" }}>
        <Container className="flightBookingMainMain">
          <Row>
            <Col md={9}>
              <div className="booking_title">
                <h3> Review Your Booking</h3>
                <Link
                  className="change_flight"
                  onClick={() => handleChangeFlight()}
                >
                  Change Flight
                </Link>
              </div>

              {flight ? (
                <DepatureDetail
                  fareRule={fareRule}
                  flight={flight}
                  type="Departure"
                  fareActive={fareActive}
                  setFareActive={setFareActive}
                />
              ) : (
                <FlightDetailSkeleton />
              )}
              {flight2 && <DepatureDetail flight={flight2} type="Return" />}
              <Row>
                <Col md={12} xs={12}>
                  <div
                    id="TRAVELLER_DETAIL"
                    className="oneCard-element"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="componentContainer ">
                      <div className="paxd">
                        <TravellerInformation
                          flight={flight}
                          handleInputChange={handleInputChange}
                          handleInputChange1={handleInputChange1}
                          handleInputChange2={handleInputChange2}
                          handleExpiryDateChange={handleExpiryDateChange}
                          handleExpiryDateChange1={handleExpiryDateChange1}
                          handleExpiryDateChange2={handleExpiryDateChange2}
                          handleDOBChange={handleDOBChange}
                          handleDOBChange1={handleDOBChange1}
                          handleDOBChange2={handleDOBChange2}
                          isinternational={isinternational}
                          formData={formData}
                          childData={childData}
                          infant={infant}
                          handleInputGST={handleInputGST}
                        />
                      </div>
                    </div>
                  </div>

                  {/* <div
                    className="componentContainer "
                    style={{ padding: "10px 10px", marginBottom: "20px" }}
                  >
                    <div className="myseatinfo">
                      <div className="booking_title">
                        <h3>Addon Services</h3>
                      </div>
                      <div
                        className="block-content-2 custom_block_content"
                        style={{ border: "none", boxShadow: "none" }}
                      >
                        {flight && (
                          <div
                            className="box-result custom_box_result"
                            style={{ display: "flex" }}
                          >
                            <div
                              className="ssrtabs ssrlists"
                              style={{ maxHeight: "400px" }}
                            >
                              <p className="fw-bold mb-2">Select Passenger</p>
                              <Nav variant="tabs" role="tablist">
                                {passengers.map((passenger, index) => (
                                  <Nav.Item key={index}>
                                    <Nav.Link
                                      id={`passenger-tab${index}`}
                                      eventKey={index}
                                      active={index === activeTab}
                                      onClick={() => handleTabChange(index)}
                                    >
                                      <div className="d-flex">
                                        <span className="asradio"></span>{" "}
                                        <label htmlFor={`rdbSSR_${index}`}>
                                          {passenger.type} {passenger.id}
                                        </label>
                                        <tt id={`adultName_${index}`}>
                                          
                                        </tt>
                                      </div>
                                      <ul
                                        className="ssrtabstabs_itinerary"
                                        style={{ padding: "0px" }}
                                      >
                                        <li style={{ marginRight: 5 }}>
                                          <span className="icon">
                                            <i
                                              className="fa fa-suitcase"
                                              aria-hidden="true"
                                            ></i>
                                          </span>
                                          <tt id={`bagdetail_${index}`}>0</tt>{" "}
                                          kg
                                        </li>
                                        <li style={{ marginRight: 5 }}>
                                          <span className="icon">
                                            <i
                                              className="fa fa-cutlery"
                                              aria-hidden="true"
                                            ></i>
                                          </span>
                                          <tt id={`mealdetail_${index}`}>0</tt>{" "}
                                          Platter
                                        </li>
                                        <li style={{ marginRight: 5 }}>
                                          <span className="icon">
                                            <i
                                              className="fa fa-chair"
                                              aria-hidden="true"
                                            ></i>
                                          </span>
                                          <tt id={`seatdetail_${index}`}>
                                            {" "}
                                            No Seat
                                          </tt>
                                          <tt
                                            id={`seatdetailinput_${index}`}
                                          ></tt>
                                        </li>
                                      </ul>
                                    </Nav.Link>
                                   
                                  </Nav.Item>
                                ))}
                               
                              </Nav>
                            </div>
                          
                            <div className="ssr_content tab-content">
                              {passengers.map((passenger, index) => (
                                <SSRContent
                                  // srdvIdx={srdvIdx}
                                  key={index}
                                  index={index}
                                  passenger={passenger}
                                  passengers={passengers}
                                  activeTab={activeTab}
                                  ssrResponse={ssrResponse}
                                  ssrResponse2={ssrResponse2}
                                  // handleChangeCurrency={handleChangeCurrency}
                                  passengerBaggagePreferences={
                                    passengerBaggagePreferences
                                  }
                                  setPassengerBaggagePreferences={
                                    setPassengerBaggagePreferences
                                  }
                                  passengerMealPreferences={
                                    passengerMealPreferences
                                  }
                                  setPassengerMealPreferences={
                                    setPassengerMealPreferences
                                  }
                                  passengerSeatPreferences={
                                    passengerSeatPreferences
                                  }
                                  setPassengerSeatPreferences={
                                    setPassengerSeatPreferences
                                  }
                                />
                              ))}
                            </div>
                          
                          </div>
                        )}
                      </div>
                    </div>
                  </div> */}

                  <BDSend
                    walletData={walletDataa}
                    onUpdate={handleDataUpdate}
                  />
                </Col>
              </Row>
            </Col>
            {!flight2 && (
              <ChargesOneWay
                flight={flight}
                setShowdetail={setShowdetail}
                showdetail={showdetail}
                // handleChangeCurrency={handleChangeCurrency}
                walletData={walletData}
                walletDatas={walletDatas}
                setOpenPayBtn={setOpenPayBtn}
                openPayBtn={openPayBtn}
                domesticMarkup={domesticMarkup}
                InternationalMarkup={InternationalMarkup}
                // emiBtn={emiBtn}
                calculateTotalFareDeduct={calculateTotalFareDeduct}
                // setEmiBtn={setEmiBtn}
                creditLimits={creditLimits}
                setCreditLimits={setCreditLimits}
                validatePassengerData={validatePassengerData}
                passengerSeatPreferences={passengerSeatPreferences}
                passengerMealPreferences={passengerMealPreferences}
                passengerBaggagePreferences={passengerBaggagePreferences}
                isinternational={isinternational}
                calculateTotalFare={calculateTotalFare}
                markups={markups}
                calculateFares={calculateFares}
                totalPassengers={totalPassengers}
                calculateFare={calculateFare}
                calculateFareForTax={calculateFareForTax}
                calculateFareDeduct={calculateFareDeduct}
                handleShowModal={handleShowModal}
              />
            )}
            {flight2 && (
              <ChargesRound
                flight={flight}
                flight2={flight2}
                setShowdetail={setShowdetail}
                showdetail={showdetail}
                calculateTotalFare={calculateTotalFare}
                walletData={walletData}
                creditLimits={creditLimits}
                setCreditLimits={setCreditLimits}
                isinternational={isinternational}
                calculateTotalFareDeduct={calculateTotalFareDeduct}
                domesticMarkup={domesticMarkup}
                InternationalMarkup={InternationalMarkup}
                walletDatas={walletDatas}
                setOpenPayBtn={setOpenPayBtn}
                openPayBtn={openPayBtn}
                validatePassengerData={validatePassengerData}
                passengerSeatPreferences={passengerSeatPreferences}
                passengerMealPreferences={passengerMealPreferences}
                passengerBaggagePreferences={passengerBaggagePreferences}
                markups={markups}
                calculateFares={calculateFares}
                totalPassengers={totalPassengers}
                calculateFare={calculateFare}
                calculateFareForTax={calculateFareForTax}
                calculateFareDeduct={calculateFareDeduct}
                handleShowModal={handleShowModal}
              />
            )}
          </Row>
        </Container>
        {openPayBtn ? (
          <div
            style={{
              position: "absolute",
              width: "100%",
              top: "0px",
              height: "100%",
              zIndex: "10",
            }}
          >
            <FlightPayModal
              flight={flight}
              flight2={flight2}
              openPayBtn={openPayBtn}
              setOpenPayBtn={setOpenPayBtn}
              formData={formData}
              childData={childData}
              walletDataaa={walletDataa}
              infant={infant}
              walletDatas={walletDatas}
              domesticMarkup={domesticMarkup}
              isinternational={isinternational}
              InternationalMarkup={InternationalMarkup}
              handleTicketBook={handleTicketBook}
              calculateTotalFare={calculateTotalFare}
              handleTicketBookRound={handleTicketBookRound}
              passengerSeatPreferences={passengerSeatPreferences}
              passengerMealPreferences={passengerMealPreferences}
              passengerBaggagePreferences={passengerBaggagePreferences}
              loading={loading}
              markups={markups}
              calculateFares={calculateFares}
              totalPassengers={totalPassengers}
              calculateFare={calculateFare}
              calculateFareForTax={calculateFareForTax}
              handleShowModal={handleShowModal}
              calculateFareDeduct={calculateFareDeduct}
              handleCloseModal={handleCloseModal}
            />
          </div>
        ) : (
          ""
        )}
      </div>
      <div
        style={{
          textAlign: "center",
          position: "sticky",
          bottom: "0px",
          backgroundImage:
            "linear-gradient(90deg, #8b3eea 20%, #530597 40%, #2b2540 90%)",
          // backgroundImage: "linear-gradient(to right, #DA22FF 0%, #9733EE 51%, #DA22FF 100%)",
          color: "#fff",
          paddingBlock: "3px",
          fontSize: "12px",
          letterSpacing: "3px",
        }}
      >
        {timer.minutes !== null
          ? `${timer.minutes} min   ${timer.seconds} sec`
          : "loading..."}{" "}
      </div>

      <Modal show={showsessionModal} onHide={handleOk} centered>
        <Modal.Body className="text-center">
          <FaClock size={50} style={{ color: "#8b3eea" }} />
          <h4 className="mt-3">Your session is expired</h4>
          <p>Click OK to continue with a new search</p>
          <Button
            variant="primary"
            onClick={handleOk}
            style={{
              background: "#8b3eea",
              border: "none",
              padding: "10px 20px",
              fontSize: "16px",
            }}
          >
            OK
          </Button>
        </Modal.Body>
      </Modal>

      <div className="confirmation_modalsssss">
        <Modal show={showModal} onHide={handleCloseModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Confirm & Edit Your Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="passenger-detailssssss">
              {formData.map((data, index) => (
                <React.Fragment key={index}>
                  <Col
                    sm={12}
                    className="passport_field"
                    style={{
                      backgroundImage:
                        "linear-gradient(to right, rgb(221, 200, 255) 0%, rgb(250, 248, 255) 51%, rgb(245 236 249) 100%)",
                      padding: "10px",
                    }}
                  >
                    <div className="form_field_col2">
                      <div
                        className="contact_label cus_label ontact_label_bfswif"
                        style={{ marginBottom: "0px" }}
                      >
                        <Form.Label>Adults {index + 1}</Form.Label>
                      </div>
                    </div>
                    <div style={{ marginBottom: "5px" }}>
                      <Row>
                        <Col
                          md={4}
                          className="form_field form_select_fieldssssss"
                        >
                          <div className="cus_field_input cus_select_titlessssss">
                            <Form.Control
                              as="select"
                              name={`title${index}`}
                              className="title form-control commoninputreset"
                              onChange={(e) => handleInputChange(index, e)}
                              autoComplete="off"
                              value={data.title || ""}
                            >
                              <option>Title</option>
                              <option value="Mr">Mr.</option>
                              <option value="Ms">Ms.</option>
                              <option value="Mrs">Mrs.</option>
                            </Form.Control>
                          </div>
                          <div className="cus_field_input cus_name_fieldssss">
                            <Form.Label className="travellers-service-form-controll">
                              Title & First Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`firstName${index}`}
                              placeholder="First Name"
                              className="form-control firstname commoninputreset"
                              onChange={(e) => handleInputChange(index, e)}
                              value={data.firstName || ""}
                              autoComplete="off"
                            />
                          </div>
                        </Col>
                        <Col className="form_field" md={4}>
                          <div className="cus_field_input cus_name_field">
                            <Form.Label className="travellers-service-form-controll">
                              Last Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`lastName${index}`}
                              placeholder="Last Name"
                              className="form-control firstname commoninputreset"
                              onChange={(e) => handleInputChange(index, e)}
                              value={data.lastName || ""}
                              autoComplete="off"
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="date_field">
                            <div
                              className="cus_field_input"
                              style={{ marginTop: "20px" }}
                            >
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  label="Date of Birth"
                                  name={`date${index}`}
                                  value={data.date ? dayjs(data.date) : null}
                                  onChange={(newValue) => {
                                    const syntheticEvent = {
                                      target: {
                                        name: `date${index}`,
                                        value:
                                          newValue?.format("YYYY-MM-DD") || "",
                                      },
                                    };
                                    handleInputChange(index, syntheticEvent);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      fullWidth
                                      placeholder="Date of Birth"
                                      autoComplete="off"
                                      style={{ height: "20px", color: "#000" }}
                                      className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>

                    {isinternational && (
                      <div>
                        {/* <Col sm={2} className="form_field_col2">
            <div className="contact_label cus_label">
              <Form.Label>Passport Detail</Form.Label>
            </div>
          </Col> */}
                        <Row>
                          <Col lg={4} className="form_field">
                            <div className="cus_field_input cus_name_field">
                              <Form.Label className="travellers-service-form-controll">
                                Passport Number
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name={`passport${index}`}
                                placeholder="Passport No."
                                className="form-control firstname commoninputreset"
                                value={data.passport || ""}
                                onChange={(e) => handleInputChange(index, e)}
                                autoComplete="off"
                              />
                            </div>
                          </Col>

                          <Col lg={4} className="date_field">
                            <div
                              className="cus_field_input"
                              style={{ marginTop: "25px" }}
                            >
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  label="Expiry Date"
                                  name={`expiryDate${index}`} // Dynamically set the name
                                  value={
                                    data.expirydate
                                      ? dayjs(data.expirydate, "DD-MM-YYYY")
                                      : null // Convert string to dayjs object with the correct format
                                  }
                                  onChange={(newValue) => {
                                    // Create a synthetic event to match handleInputChange's expected input
                                    const syntheticEvent = {
                                      target: {
                                        name: `expiryDate${index}`,
                                        value:
                                          newValue?.format("DD-MM-YYYY") || "", // Format as DD-MM-YYYY
                                      },
                                    };
                                    handleInputChange(index, syntheticEvent);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      fullWidth
                                      placeholder="Expiry Date"
                                      autoComplete="off"
                                      style={{ height: "auto" }}
                                      inputProps={{
                                        ...params.inputProps,
                                        min: new Date()
                                          .toISOString()
                                          .split("T")[0], // Set min to today's date
                                      }}
                                      className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            </div>
                          </Col>

                          <Col lg={4} className="date_field">
                            <div className="cus_field_input ">
                              <Form.Label
                                className="travellers-service-form-controll"
                                style={{ marginLeft: "10px" }}
                              >
                                Select Country
                              </Form.Label>
                              <Form.Control
                                as="select"
                                name={`nationality${index}`}
                                className="title form-control commoninputreset selection_country_Ccode_Travell"
                                onChange={(e) => handleInputChange(index, e)}
                                value={data.nationality || ""}
                                autoComplete="off"
                              >
                                <option value="Nationality">Nationality</option>
                                {countries.map((country, idx) => (
                                  <option key={idx} value={country.Code}>
                                    {country.Name}
                                  </option>
                                ))}
                              </Form.Control>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </Col>
                </React.Fragment>
              ))}

              {childData.map((data, index) => (
                <React.Fragment key={index}>
                  <Col
                    sm={12}
                    className="passport_field"
                    style={{
                      backgroundImage:
                        "linear-gradient(to right, rgb(221, 200, 255) 0%, rgb(250, 248, 255) 51%, rgb(245 236 249) 100%)",
                      padding: "10px",
                    }}
                  >
                    <div className="form_field_col2">
                      <div
                        className="contact_label cus_label ontact_label_bfswif"
                        style={{ marginBottom: "0px" }}
                      >
                        <Form.Label>Child {index + 1}</Form.Label>
                      </div>
                    </div>
                    <div style={{ marginBottom: "5px" }}>
                      <Row>
                        <Col
                          md={4}
                          className="form_field form_select_fieldssssss"
                        >
                          <div className="cus_field_input cus_select_titlessssss">
                            <Form.Control
                              as="select"
                              name={`title${index}`}
                              className="title form-control commoninputreset"
                              onChange={(e) => handleInputChange1(index, e)}
                              autoComplete="off"
                              value={data.title || ""}
                            >
                              <option>Title</option>
                              <option value="Mr">Mr.</option>
                              <option value="Ms">Ms.</option>
                              <option value="Mrs">Mrs.</option>
                            </Form.Control>
                          </div>
                          <div className="cus_field_input cus_name_fieldssss">
                            <Form.Label className="travellers-service-form-controll">
                              Title & First Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`firstName${index}`}
                              placeholder="First Name"
                              className="form-control firstname commoninputreset"
                              onChange={(e) => handleInputChange1(index, e)}
                              value={data.firstName || ""}
                              autoComplete="off"
                            />
                          </div>
                        </Col>
                        <Col className="form_field" md={4}>
                          <div className="cus_field_input cus_name_field">
                            <Form.Label className="travellers-service-form-controll">
                              Last Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`lastName${index}`}
                              placeholder="Last Name"
                              className="form-control firstname commoninputreset"
                              onChange={(e) => handleInputChange1(index, e)}
                              value={data.lastName || ""}
                              autoComplete="off"
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="date_field">
                            <div
                              className="cus_field_input"
                              style={{ marginTop: "20px" }}
                            >
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  label="Date of Birth"
                                  name={`date${index}`}
                                  value={data.date ? dayjs(data.date) : null}
                                  onChange={(newValue) => {
                                    const syntheticEvent = {
                                      target: {
                                        name: `date${index}`,
                                        value:
                                          newValue?.format("YYYY-MM-DD") || "",
                                      },
                                    };
                                    handleInputChange1(index, syntheticEvent);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      fullWidth
                                      placeholder="Date of Birth"
                                      autoComplete="off"
                                      style={{ height: "20px", color: "#000" }}
                                      className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>

                    {isinternational && (
                      <div>
                        {/* <Col sm={2} className="form_field_col2">
            <div className="contact_label cus_label">
              <Form.Label>Passport Detail</Form.Label>
            </div>
          </Col> */}
                        <Row>
                          <Col lg={4} className="form_field">
                            <div className="cus_field_input cus_name_field">
                              <Form.Label className="travellers-service-form-controll">
                                Passport Number
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name={`passport${index}`}
                                placeholder="Passport No."
                                className="form-control firstname commoninputreset"
                                value={data.passport || ""}
                                onChange={(e) => handleInputChange1(index, e)}
                                autoComplete="off"
                              />
                            </div>
                          </Col>

                          <Col lg={4} className="date_field">
                            <div
                              className="cus_field_input"
                              style={{ marginTop: "25px" }}
                            >
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  label="Expiry Date"
                                  name={`expirydate${index}`}
                                  value={
                                    data.expirydate
                                      ? dayjs(data.expirydate, "DD-MM-YYYY")
                                      : null
                                  }
                                  onChange={(newValue) => {
                                    const syntheticEvent = {
                                      target: {
                                        name: `expirydate${index}`,
                                        value:
                                          newValue?.format("DD-MM-YYYY") || "",
                                      },
                                    };
                                    handleInputChange1(index, syntheticEvent);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      fullWidth
                                      placeholder="Expiry Date"
                                      autoComplete="off"
                                      style={{ height: "auto" }}
                                      inputProps={{
                                        ...params.inputProps,
                                        min: new Date()
                                          .toISOString()
                                          .split("T")[0],
                                      }}
                                      className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            </div>
                          </Col>

                          <Col lg={4} className="date_field">
                            <div className="cus_field_input ">
                              <Form.Label
                                className="travellers-service-form-controll"
                                style={{ marginLeft: "10px" }}
                              >
                                Select Country
                              </Form.Label>
                              <Form.Control
                                as="select"
                                name={`nationality${index}`}
                                className="title form-control commoninputreset selection_country_Ccode_Travell"
                                onChange={(e) => handleInputChange1(index, e)}
                                value={data.nationality || ""}
                                autoComplete="off"
                              >
                                <option value="Nationality">Nationality</option>
                                {countries.map((country, idx) => (
                                  <option key={idx} value={country.Code}>
                                    {country.Name}
                                  </option>
                                ))}
                              </Form.Control>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </Col>
                </React.Fragment>
              ))}

              {infant.map((data, index) => (
                <React.Fragment key={index}>
                  <Col
                    sm={12}
                    className="passport_field"
                    style={{
                      backgroundImage:
                        "linear-gradient(to right, rgb(221, 200, 255) 0%, rgb(250, 248, 255) 51%, rgb(245 236 249) 100%)",
                      padding: "10px",
                    }}
                  >
                    <div className="form_field_col2">
                      <div
                        className="contact_label cus_label ontact_label_bfswif"
                        style={{ marginBottom: "0px" }}
                      >
                        <Form.Label>Infant {index + 1}</Form.Label>
                      </div>
                    </div>
                    <div style={{ marginBottom: "5px" }}>
                      <Row>
                        <Col
                          md={4}
                          className="form_field form_select_fieldssssss"
                        >
                          <div className="cus_field_input cus_select_titlessssss">
                            <Form.Control
                              as="select"
                              name={`title${index}`}
                              className="title form-control commoninputreset"
                              onChange={(e) => handleInputChange2(index, e)}
                              autoComplete="off"
                              value={data.title || ""}
                            >
                              <option>Title</option>
                              <option value="Mr">Mr.</option>
                              <option value="Ms">Ms.</option>
                              <option value="Mrs">Mrs.</option>
                            </Form.Control>
                          </div>
                          <div className="cus_field_input cus_name_fieldssss">
                            <Form.Label className="travellers-service-form-controll">
                              Title & First Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`firstName${index}`}
                              placeholder="First Name"
                              className="form-control firstname commoninputreset"
                              onChange={(e) => handleInputChange2(index, e)}
                              value={data.firstName || ""}
                              autoComplete="off"
                            />
                          </div>
                        </Col>
                        <Col className="form_field" md={4}>
                          <div className="cus_field_input cus_name_field">
                            <Form.Label className="travellers-service-form-controll">
                              Last Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name={`lastName${index}`}
                              placeholder="Last Name"
                              className="form-control firstname commoninputreset"
                              onChange={(e) => handleInputChange2(index, e)}
                              value={data.lastName || ""}
                              autoComplete="off"
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="date_field">
                            <div
                              className="cus_field_input"
                              style={{ marginTop: "20px" }}
                            >
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  label="Date of Birth"
                                  name={`date${index}`}
                                  value={data.date ? dayjs(data.date) : null}
                                  onChange={(newValue) => {
                                    const syntheticEvent = {
                                      target: {
                                        name: `date${index}`,
                                        value:
                                          newValue?.format("YYYY-MM-DD") || "",
                                      },
                                    };
                                    handleInputChange2(index, syntheticEvent);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      fullWidth
                                      placeholder="Date of Birth"
                                      autoComplete="off"
                                      style={{ height: "20px", color: "#000" }}
                                      className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>

                    {isinternational && (
                      <div>
                        {/* <Col sm={2} className="form_field_col2">
            <div className="contact_label cus_label">
              <Form.Label>Passport Detail</Form.Label>
            </div>
          </Col> */}
                        <Row>
                          <Col lg={4} className="form_field">
                            <div className="cus_field_input cus_name_field">
                              <Form.Label className="travellers-service-form-controll">
                                Passport Number
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name={`passport${index}`}
                                placeholder="Passport No."
                                className="form-control firstname commoninputreset"
                                value={data.passport || ""}
                                onChange={(e) => handleInputChange2(index, e)}
                                autoComplete="off"
                              />
                            </div>
                          </Col>

                          <Col lg={4} className="date_field">
                            <div
                              className="cus_field_input"
                              style={{ marginTop: "25px" }}
                            >
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  label="Expiry Date"
                                  name={`expirydate${index}`}
                                  value={
                                    data.expirydate
                                      ? dayjs(data.expirydate, "DD-MM-YYYY")
                                      : null
                                  }
                                  onChange={(newValue) => {
                                    const syntheticEvent = {
                                      target: {
                                        name: `expirydate${index}`,
                                        value:
                                          newValue?.format("DD-MM-YYYY") || "",
                                      },
                                    };
                                    handleInputChange2(index, syntheticEvent);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      fullWidth
                                      placeholder="Expiry Date"
                                      autoComplete="off"
                                      style={{ height: "auto" }}
                                      inputProps={{
                                        ...params.inputProps,
                                        min: new Date()
                                          .toISOString()
                                          .split("T")[0],
                                      }}
                                      className="commoninputreset form-control datepicker-infant-time-start hasDatepicker"
                                    />
                                  )}
                                />
                              </LocalizationProvider>
                            </div>
                          </Col>

                          <Col lg={4} className="date_field">
                            <div className="cus_field_input ">
                              <Form.Label
                                className="travellers-service-form-controll"
                                style={{ marginLeft: "10px" }}
                              >
                                Select Country
                              </Form.Label>
                              <Form.Control
                                as="select"
                                name={`nationality${index}`}
                                className="title form-control commoninputreset selection_country_Ccode_Travell"
                                onChange={(e) => handleInputChange2(index, e)}
                                value={data.nationality || ""}
                                autoComplete="off"
                              >
                                <option value="Nationality">Nationality</option>
                                {countries.map((country, idx) => (
                                  <option key={idx} value={country.Code}>
                                    {country.Name}
                                  </option>
                                ))}
                              </Form.Control>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </Col>
                </React.Fragment>
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleConfirmModal}
              style={{ padding: "8px 25px" }}
            >
              Continue Booking
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default FlightDetail;
